const keysOfSubscriptionMetadata = ["billingSystem", "currency"];

export { keysOfSubscriptionMetadata };
